import { createContext, useContext, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getFooter, updateFooter } from "../../api/footer";
import { getIntialValues, generatePayload } from "./helper";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();

  const getFooterQuery = useQuery({
    queryKey: ["footer"],
    queryFn: getFooter,
  });

  const updateFooterMutation = useMutation({
    mutationFn: updateFooter,
    onSuccess: () => {
      toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
      getFooterQuery.refetch();
    },
    onError: () => {
      toaster.error(Const.MESSAGES.FAILED, "Error updating footer.");
    },
  });

  const initialValues = useMemo(() => {
    const footerData = getFooterQuery?.data?.data || {};
    return getIntialValues(footerData);
  }, [getFooterQuery?.data]);

  const handleSubmit = (values) => {
    const payload = generatePayload(values);
    updateFooterMutation.mutate(payload);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        updateFooterQuery: updateFooterMutation,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const usePageProvider = () => {
  return useContext(PageContext);
};
